'use strict';

var lastId = 0;
function generateId () {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id-';
  lastId++;
  return "".concat(prefix).concat(lastId);
}

module.exports = generateId;
